export default __webpack_public_path__ + "static/media/decapitation.cdbf68eb.png";